import { render, staticRenderFns } from "./AppDialogComponent.vue?vue&type=template&id=6838a43a&scoped=true"
import script from "./AppDialogComponent.vue?vue&type=script&lang=js"
export * from "./AppDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./AppDialogComponent.vue?vue&type=style&index=0&id=6838a43a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6838a43a",
  null
  
)

export default component.exports